module.exports = __webpack_public_path__ + "img/1_011.1393cad4.jpg";